import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { checkModifica } from 'app/utils/boolean-input';

@Component({
  selector: 'sl-logo-comune',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './logo-comune.component.html',
})
export class LogoComuneComponent {

    ckeckModifica(){
        return checkModifica()
    }

}
